import { Box, Typography } from '@mui/material';
import type { Icon } from 'iconsax-react';
import type { FC, ReactNode } from 'react';

import { hasValue } from '@core/utils/equality';

import { SlabCard } from '../SlabCard/SlabCard';

type Props = {
  icon?: Icon;
  title: string;
  description?: string;
  children?: ReactNode;
  bgVariant?: 'white' | 'gray';
};

export const EmptyState: FC<Props> = ({
  icon: IconComponent,
  title,
  description,
  children,
  bgVariant = 'white',
}) => (
  <SlabCard
    sx={{
      alignItems: 'center',
      justifyContent: 'center',
      paddingY: 4,
      marginY: 0,
      backgroundColor: bgVariant === 'gray' ? 'SlabGray.50' : 'SlabGray.0',
      textAlign: 'center',
    }}
  >
    <Box display='flex' flexDirection='column' alignItems='center' textAlign='center' py={8}>
      {hasValue(IconComponent) && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 64,
            height: 64,
            mb: 1.5,
            borderRadius: '50%',
            border: 1,
            borderColor: 'SlabGray.300',
            backgroundColor: bgVariant === 'gray' ? 'SlabGray.0' : 'SlabGray.50',
            color: 'SlabGray.600',
          }}
        >
          <IconComponent variant='TwoTone' size={32} color='currentColor' />
        </Box>
      )}
      <Typography variant='body2' fontWeight={500} color='SlabGray.800' marginBottom={1}>
        {title}
      </Typography>

      <Typography maxWidth={260} variant='body3' color='text.secondary' marginBottom={2}>
        {description}
      </Typography>
      {children}
    </Box>
  </SlabCard>
);
